import { render, staticRenderFns } from "./ComparePdf.vue?vue&type=template&id=52d4d81b"
import script from "./ComparePdf.vue?vue&type=script&lang=js"
export * from "./ComparePdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports